import { LoadedProps, RouteLoadProps } from '@components/router';
import { rpx } from 'client/lib/rpx-client';

export async function load(route: RouteLoadProps) {
  const searchTerm = route.params.q || '';
  const [{ courses, cursor }, brands] = await Promise.all([
    rpx.tenants.getTenantCourses({
      searchTerm: route.params.q || '',
      secondSearchTerm: route.params.q2 || '',
      orderBy: 'createdAt',
    }),
    rpx.branding.getBrands(),
  ]);

  return {
    searchTerm,
    courses,
    cursor,
    brands: brands.map((x) => ({ id: x.id, name: x.name })),
  };
}

export type Data = LoadedProps<typeof load>['state'];
